export class Amount {
    value: number;
    currency: string;

    constructor(currency?: string, value?: number) {
        this.currency = currency || 'TL'; // Set default to TL
        this.value = value !== undefined ? value : null; // Set default to null
    }
}
